import styled from 'styled-components'
import { Form } from '@unform/web';


export const DefaultContainer = styled.div`
    display:flex;
    flex-flow:column;   
`;

export const headerContainer = styled(Form)`
  display:grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap:10px;
`

export const ContainerTable = styled.div`
    //height:500px;
    overflow:auto;
`

export const ContentTable = styled.div`    
   
    @media(min-width:500px){
        //width: 2000px;
        margin: 20px auto;
    }
`